import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=495e1e1a&scoped=true&"
import script from "./Password.vue?vue&type=script&lang=js&"
export * from "./Password.vue?vue&type=script&lang=js&"
import style0 from "./Password.vue?vue&type=style&index=0&id=495e1e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e1e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495e1e1a')) {
      api.createRecord('495e1e1a', component.options)
    } else {
      api.reload('495e1e1a', component.options)
    }
    module.hot.accept("./Password.vue?vue&type=template&id=495e1e1a&scoped=true&", function () {
      api.rerender('495e1e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Password.vue"
export default component.exports